import type { PropsWithChildren } from 'react';
import { PageHeader } from '../components/PageHeader';
import { Banner, Button, Space } from '../ui/semi';
import { useAuthorization } from './AuthorizationContext';
import { hasAnyPermission } from './permissions';

interface RequireTenantPermissionProps extends PropsWithChildren {
  anyOf: readonly string[];
  section: string;
  title: string;
}

export function RequireTenantPermission({
  anyOf,
  section,
  title,
  children,
}: RequireTenantPermissionProps) {
  const authorization = useAuthorization();

  if (authorization.error) {
    return (
      <Space vertical spacing={24} className="content-stack">
        <PageHeader section={section} title={title} description="暂时无法确认当前账号的功能权限。" />
        <Banner
          type="danger"
          title="权限信息加载失败"
          description="请检查网络或服务状态后重试。系统不会在权限未知时展示业务数据。"
          closeIcon={null}
        >
          <Button onClick={authorization.retry}>重新加载权限</Button>
        </Banner>
      </Space>
    );
  }

  if (hasAnyPermission(authorization.snapshot, anyOf)) {
    return children;
  }

  return (
    <Space vertical spacing={24} className="content-stack">
      <PageHeader section={section} title={title} description="当前账号没有访问此功能所需的权限。" />
      <Banner
        type="warning"
        title={`无权访问${title}`}
        description="请联系租户管理员调整当前账号的功能权限。"
        closeIcon={null}
      />
    </Space>
  );
}
